import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Color from "../../../assets/colors";
import { updatePDPAStatus } from "../../../redux/actions/user_action";
import {
  BoxContainer,
  ButtonStyled,
  CloseButton,
  CloseIcon,
  DialogContainer,
  HiredlyIcon,
  LinkStyled,
  PrivacyIcon,
  TextStyled,
} from "./styles";

function SharedPrivacyDialog() {
  const dispatch = useDispatch();
  const [openCheckDialog, setOpenCheckDialog] = useState(false);

  const isMobile = useMediaQuery("(max-width:640px)");
  const status = useSelector((state) => state.user.pdpaAccepted);
  const relocateStatus =
    useSelector((state) => state.user.user.relocationPreferences) ?? {};

  useEffect(() => {
    checkDialog();
  }, [status]);

  function checkDialog() {
    if (status !== null && status !== undefined) {
      if (!status) {
        setOpenCheckDialog(true);
      }
    }
  }

  function handleClose() {
    setOpenCheckDialog(false);
  }

  function handleSubmit() {
    dispatch(updatePDPAStatus()).then(() => {
      handleClose();
    });
  }

  return (
    <DialogContainer open={openCheckDialog}>
      <BoxContainer
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        sx={{ width: "100%", height: "100%" }}
      >
        <BoxContainer
          alignItems={"center"}
          gap={"0.625rem"}
          width={"100%"}
          height={"100%"}
          padding={"1.5rem 1.5rem 1rem"}
          borderBottom={"1px solid " + Color.grey}
        >
          <HiredlyIcon />
          <TextStyled
            variant="h5"
            fontSize={"1.25rem"}
            lineHeight={"1.5rem"}
            fontWeight=" 700"
          >
            We’ve updated our Privacy Policy
          </TextStyled>
          <CloseButton onClick={handleClose}>
            <CloseIcon />
          </CloseButton>
        </BoxContainer>

        <BoxContainer
          flexDirection={"column"}
          alignItems={"center"}
          padding={isMobile ? "0.5rem 1rem 1.5rem" : "1rem 1.5rem"}
          gap={isMobile ? "0.5rem" : "1rem"}
        >
          <PrivacyIcon />
          <BoxContainer flexDirection={"column"} gap={"1rem"}>
            <TextStyled
              variant="p"
              fontSize={"0.875rem"}
              lineHeight={"1.25rem"}
              fontWeight={"400"}
              color={"rgba(0, 0, 0, 0.6)"}
            >
              Your privacy matters to us. We’ve updated our Privacy Policy to
              ensure your experience is secure. Please review and accept our
              latest policies and terms to proceed.
            </TextStyled>
            <TextStyled
              variant="p"
              fontSize={"0.875rem"}
              lineHeight={"1.25rem"}
              fontWeight={"400"}
              color={"rgba(0, 0, 0, 0.6)"}
            >
              Hiredly’s{" "}
              <LinkStyled href="/privacy-policy">Privacy Policy</LinkStyled> and
              the{" "}
              <LinkStyled href="/terms-and-conditions">
                Terms & Conditions
              </LinkStyled>
              .
            </TextStyled>
          </BoxContainer>
        </BoxContainer>

        <BoxContainer
          flexDirection={"column"}
          alignItems={"center"}
          gap={"0.625rem"}
          padding={"1rem 1.875rem"}
          width={"100%"}
          borderTop={"1px solid " + Color.grey}
        >
          <ButtonStyled onClick={handleSubmit}>{"Accept"}</ButtonStyled>
          <LinkStyled href="/privacy-policy" type="important">
            View Our Policy
          </LinkStyled>
        </BoxContainer>
      </BoxContainer>
    </DialogContainer>
  );
}

export default SharedPrivacyDialog;
